import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/wrappers/Http';
import { ConfigService } from './config/config.service';
import { EndPoints } from '../configs';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpService, private configs: ConfigService) { }




  async getTokenRequest(){
    let params = {
      "refreshToken": this.configs.USER_AUTHORISATION.refresh_token || ""
    }

    let api = this.configs.PROXIES.userService.endsWith('v2/')
      ? this.configs.PROXIES.userService.split('v2/')[0]
      : this.configs.PROXIES.userService

    try {
      const res = await this.http.Post(api, EndPoints.refreshToken, params, "refreshToken");

      if (res.erc == 1 && res.data && res.data.token) {
        this.configs.USER_AUTHORISATION = {
          ...this.configs.USER_AUTHORISATION,
          access_token: 'Bearer ' + res.data.token,
          expiry: new Date(res.data.expire_at)
        }
      } else {
        this.configs.USER_AUTHORISATION = null;
      }
    } catch(err) {
      console.error('Token refresh error:', err);
      this.configs.USER_AUTHORISATION = null;
    }
  }
}
